import { j as jsxRuntimeExports } from './jsx-runtime-D2XkDcqR.js';

const LinkedInTracking = ({ id }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  id ? /* @__PURE__ */ jsxRuntimeExports.jsx("script", { async: true, src: getScriptSrc() }) : null,
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "script",
    {
      dangerouslySetInnerHTML: {
        __html: getScriptInit(id)
      }
    }
  )
] });
const getScriptSrc = () => "https://snap.licdn.com/li.lms-analytics/insight.beta.min.js";
const getScriptInit = (id) => [
  `_linkedin_data_partner_ids=[${JSON.stringify(id)}]`,
  `lintrk=function(a,b){lintrk.q.push([a,b])}`,
  `lintrk.q=[]`
].join(";");

export { LinkedInTracking };
